<style lang="scss" scoped>
  .export-button {
    color:#71767D;
    font-family:'Montserrat';
    font-weight:700;
    font-size:12px;
    line-height:18px;
  }
  .export-button:hover {
    background-color:#5F33FF;
    color:#FFFFFF;
  }
  .pipeline-select, .user-select {
    min-width: 210px;
  }

  .offscreen-rendering {
    opacity: 0;
  }

  #progress-export-container {
    width: 100%;
    max-width: 1064px;
  }

  .hide-export-container {
    position: absolute;
    left: 9999px;
  }
</style>

<template>
  <div class="progress-view" id="progress-view-container">
    <div class="row">
      <div class="col-12 pl-30px d-flex align-items-center">
        <h2 class="page-subtitle">
          {{ __('Esse é o seu progresso') }}
        </h2>
        <div
          class="ml-3"
          v-if="loading"
        >
          <span class="loading"><i class="fa fa-circle-o-notch fa-spin" /></span>
        </div>
        <div
          class="ml-3"
          v-else-if="pipelines.length && ! seller"
        >
          <InputDropdown
            class="pipeline-select"
            id="pipeline.select"
            truncate-at="20"
            :items="allPipelines"
            :selected="__(pipeline.name)"
            @select="(pipeline) => selectPipeline(pipeline)"
          />
        </div>
        <div
          class="mx-3"
          v-if="users.length && ! seller"
        >
          <InputDropdown
            class="user-select"
            id="user.select"
            truncate-at="20"
            :items="allUsers"
            :selected="__(user.name)"
            @select="(user) => selectUser(user)"
          />
        </div>
        <div class="ml-auto">
          <InputDaterange
            name="range"
            id="range"
            position="left"
            theme="modern"
            preset="report"
            :placeholder="__('Últimos 15 dias')"
            v-model="range"
            :start="14"
            :width="200"
            @update="(value) => range = value"
          />
        </div>
        <div>
          <button id="export-button"
            v-on:click="openExportModal"
            class="btn btn-bulldesk ml-3 export-button"
          >
            <span>Exportar progresso</span>
          </button>
        </div>
      </div>
    </div>
    <div class="row px-12px">
      <div class="col-12 mb-30px">
        <div class="row" id="progress-row">
          <div class="col-12 border-0 mt-4">
            <ProgressDealsWidget
              interval="previous"
              :user="user.id"
              :range="range"
              :pipeline="pipeline.id"
              :dealToExport="progressCharts.dealsToExport"
              :pngSrc="pngSrc"
              :displaySvg="displaySvg"
            />
          </div>
          <div class="row col-12 my-xxl-4" style="padding: 0px;margin: 0px;">
            <div class="col-4 border-0 h-xxl-100 my-4 my-xxl-0">
              <ProgressDealTop5Widget
                name="deal.started"
                id="deal.started"
                :user="user.id"
                :range="range"
                :pipeline="pipeline.id"
              />
            </div>
            <div class="col-4 border-0 h-xxl-100 my-4 my-xxl-0">
              <ProgressDealTop5Widget
                name="deal.won"
                id="deal.won"
                :user="user.id"
                :range="range"
                :pipeline="pipeline.id"
              />
            </div>
            <div class="col-4 border-0 h-xxl-100 my-4 my-xxl-0">
              <ProgressDealTop5Widget
                name="deal.lost"
                id="deal.lost"
                :user="user.id"
                :range="range"
                :pipeline="pipeline.id"
              />
            </div>
          </div>
          <div class="row col-12 mb-xxl-4" style="padding: 0px;margin: 0px;">
            <div class="col-4 border-0 h-xxl-100 mb-4">
              <ProgressActivityWidget
                name="activity.started"
                id="activity.started"
                :user="user.id"
                :range="range"
                :pipeline="pipeline.id"
              />
            </div>
            <div class="col-4 border-0 h-xxl-100 mb-4">
              <ProgressActivityWidget
                name="activity.scheduled"
                id="activity.scheduled"
                :user="user.id"
                :range="range"
                :pipeline="pipeline.id"
              />
            </div>
            <div class="col-4 border-0 h-xxl-100 mb-4">
              <ProgressActivityWidget
                name="activity.completed"
                id="activity.completed"
                :user="user.id"
                :range="range"
                :pipeline="pipeline.id"
              />
            </div>
          </div>
          <div class="row col-12 mb-xxl-4" style="padding: 0px;margin: 0px;">
            <div class="col-4 border-0 h-xxl-100 mb-4">
              <ProgressActivityWidget
                name="activity.successful"
                id="activity.successful"
                :user="user.id"
                :range="range"
                :pipeline="pipeline.id"
              />
            </div>
            <div class="col-4 border-0 h-xxl-100 mb-4">
              <ProgressActivityWidget
                name="activity.unsuccessful"
                id="activity.unsuccessful"
                :user="user.id"
                :range="range"
                :pipeline="pipeline.id"
              />
            </div>
            <div class="col-4 border-0 h-xxl-100 mb-4">
              <ProgressActivityWidget
                name="activity.deleted"
                id="activity.deleted"
                :user="user.id"
                :range="range"
                :pipeline="pipeline.id"
              />
            </div>
          </div>
          <div class="col-xxl-12 border-0" id="chart.deal.started">
            <ProgressChartDealWidget
              name="deal.started"
              id="deal-started"
              :user="user.id"
              :range="range"
              :pipeline="pipeline.id"
            />
          </div>
          <div class="col-xxl-12 border-0 my-4" id="chart.deal.won">
            <ProgressChartDealWidget
              name="deal.won"
              id="deal-won"
              :user="user.id"
              :range="range"
              :pipeline="pipeline.id"
            />
          </div>
          <div class="col-xxl-12 border-0" id="chart.deal.lost">
            <ProgressChartDealWidget
              name="deal.lost"
              id="deal-lost"
              :user="user.id"
              :range="range"
              :pipeline="pipeline.id"
            />
          </div>
          <div class="col-xxl-12 border-0 my-4" id="chart.deal.progress">
            <ProgressChartDealWidget
              name="deal.progress"
              id="deal-progress"
              :user="user.id"
              :range="range"
              :pipeline="pipeline.id"
            />
          </div>
          <div class="col-xxl-12 border-0" id="chart.deal.conversion">
            <ProgressChartDealConversionWidget
              name="deal.conversion"
              id="deal-conversion"
              :user="user.id"
              :range="range"
              :pipeline="pipeline.id"
            />
          </div>
        </div>
      </div>
    </div>
    <div :class="{ 'hide-export-container': !showExportContainer }" id="progress-export-container">
      <div class="row" id="progress-row">
        <div class="col-12 border-0" id="deals-started-closed-lost">
          <ProgressDealsWidget
            ref="deals-started-closed-lost"
            interval="previous"
            :user="user.id"
            :range="range"
            :pipeline="pipeline.id"
            :dealToExport="progressCharts.dealsToExport"
            :pngSrc="pngSrc"
            :displaySvg="displaySvg"
          />
        </div>
        <div class="col-12 border-0" id="users-deals-started">
          <ProgressDealTop5Widget
            ref="users-deals-started"
            name="deal.started"
            :user="user.id"
            :range="range"
            :pipeline="pipeline.id"
          />
        </div>
        <div class="col-12 border-0" id="users-deals-closed">
          <ProgressDealTop5Widget
            ref="users-deals-closed"
            name="deal.won"
            :user="user.id"
            :range="range"
            :pipeline="pipeline.id"
          />
        </div>
        <div class="col-12 border-0" id="users-deals-lost">
          <ProgressDealTop5Widget
            ref="users-deals-lost"
            name="deal.lost"
            :user="user.id"
            :range="range"
            :pipeline="pipeline.id"
          />
        </div>
        <div class="col-12 border-0" id="activities-started">
          <ProgressActivityWidget
            ref="activities-started"
            name="activity.started"
            :user="user.id"
            :range="range"
            :pipeline="pipeline.id"
          />
        </div>
        <div class="col-12 border-0" id="activities-closed">
          <ProgressActivityWidget
            ref="activities-closed"
            name="activity.completed"
            :user="user.id"
            :range="range"
            :pipeline="pipeline.id"
          />
        </div>
        <div class="col-12 border-0" id="activities-pending">
          <ProgressActivityWidget
            ref="activities-pending"
            name="activity.scheduled"
            :user="user.id"
            :range="range"
            :pipeline="pipeline.id"
          />
        </div>
        <div class="col-12 border-0" id="activities-successful">
          <ProgressActivityWidget
            ref="activities-successful"
            name="activity.successful"
            :user="user.id"
            :range="range"
            :pipeline="pipeline.id"
          />
        </div>
        <div class="col-12 border-0" id="activities-unsuccessful">
          <ProgressActivityWidget
            ref="activities-unsuccessful"
            name="activity.unsuccessful"
            :user="user.id"
            :range="range"
            :pipeline="pipeline.id"
          />
        </div>
        <div class="col-12 border-0" id="activities-deleted">
          <ProgressActivityWidget
            ref="activities-deleted"
            name="activity.deleted"
            :user="user.id"
            :range="range"
            :pipeline="pipeline.id"
          />
        </div>
        <div class="col-12 border-0" id="chart-deal-started">
          <ProgressChartDealWidget
            ref="chart-deal-started"
            name="deal.started"
            :user="user.id"
            :range="range"
            :pipeline="pipeline.id"
          />
        </div>
        <div class="col-12 border-0" id="chart-deal-won">
          <ProgressChartDealWidget
            ref="chart-deal-won"
            name="deal.won"
            :user="user.id"
            :range="range"
            :pipeline="pipeline.id"
          />
        </div>
        <div class="col-12 border-0" id="chart-deal-lost">
          <ProgressChartDealWidget
            ref="chart-deal-lost"
            name="deal.lost"
            :user="user.id"
            :range="range"
            :pipeline="pipeline.id"
          />
        </div>
        <div class="col-12 border-0" id="chart-deal-progress">
          <ProgressChartDealWidget
            ref="chart-deal-progress"
            name="deal.progress"
            :user="user.id"
            :range="range"
            :pipeline="pipeline.id"
          />
        </div>
        <div class="col-12 border-0" id="chart-deal-conversion">
          <ProgressChartDealConversionWidget
            ref="chart-deal-conversion"
            name="deal.conversion"
            :user="user.id"
            :range="range"
            :pipeline="pipeline.id"
          />
        </div>
      </div>
    </div>
    <canvas ref="canvas" width="153" height="153"></canvas>
    <ExportProgressModal
      title="Exportar progresso"
      :range="range"
      :user="user"
      :pipeline="pipeline"
    />
  </div>
</template>

<script>
import html2canvas from 'html2canvas';

export default {
  props: {
    currentUser: {
      type: Object,
      required: true,
    },
    seller: {
      type: Boolean,
      default: false,
    },
  },

  mounted() {
    Bus.$on('exportProgressModalShown', this.handleExportProgressModalShown);
    Bus.$on('exportProgressModalHidden', this.handleExportProgressModalHidden);
    Bus.$on('parseHtmlToCanvasAndCreateAnImage', async (params) => {
      try {
        await this.parseHtmlToCanvasAndCreateAnImage(params);
      } catch (error) {
        Bus.$emit('exportGraphsError', error);
      }
    });
  },

  beforeDestroy() {
    Bus.$off('parseHtmlToCanvasAndCreateAnImage');
  },

  store: ['users'],

  created () {
    this.getPipelines();
  },

  data () {
    return {
      pipeline: {
        id: 'all',
        name: 'Todos os pipelines',
      },
      user: {
        id: '',
        name: 'Todos os usuários',
      },
      pipelines: [],
      range: null,
      loading: false,
      progressCharts: {
        "users.deals.started": { id: "#users-deals-started", ref: "users-deals-started" },
        "users.deals.closed": { id: "#users-deals-closed", ref: "users-deals-closed" },
        "users.deals.lost": { id: "#users-deals-lost", ref: "users-deals-lost" },
        "activities.started": { id: "#activities-started", ref: "activities-started" },
        "activities.closed": { id: "#activities-closed", ref: "activities-closed" },
        "activities.pending": { id: "#activities-pending", ref: "activities-pending" },
        "activities.successful": { id: "#activities-successful", ref: "activities-successful" },
        "activities.unsuccessful": { id: "#activities-unsuccessful", ref: "activities-unsuccessful" },
        "activities.deleted": { id: "#activities-deleted", ref: "activities-deleted" },
        "chart.deal.started": { id: "#chart-deal-started", ref: "chart-deal-started" },
        "chart.deal.won": { id: "#chart-deal-won", ref: "chart-deal-won" },
        "chart.deal.lost": { id: "#chart-deal-lost", ref: "chart-deal-lost" },
        "chart.deal.progress": { id: "#chart-deal-progress", ref: "chart-deal-progress" },
        "chart.deal.conversion": { id: "#chart-deal-conversion", ref: "chart-deal-conversion" },
      },
      selectedDealsTypes: ["deals.started", "deals.closed", "deals.lost"],
      dealsTypes: ["deals.started", "deals.closed", "deals.lost"],
      progressImages: [],
      svgIds: ["started", "closed", "lost"],
      displaySvg: {
        started: true,
        closed: true,
        lost: true,
      },
      pngSrc: {
        started: null,
        closed: null,
        lost: null,
      },
      deviceScale: window.devicePixelRatio,
      showExportContainer: false,
    };
  },

  computed: {
    allPipelines () {
      return _.union([{ id: 'all', name: this.__('Todos os pipelines') }], this.pipelines, [{ id: 'none', name: this.__('Atividades no lead'), tooltip: this.__('Atividades que são registradas no perfil do lead') }]);
    },

    allUsers () {
      return _.union([{ name: this.__('Todos os usuários') }], this.users);
    },
  },

  methods: {
    getPipelines () {
      this.loading = true;

      this.$http.get('/pipeline')
        .then((response) => {
          this.pipelines = response.data.pipelines.map((item) => ({ ...item, name: this.__(item.name) }));
        })
        .finally(() => {
          this.loading = false;
        });
    },

    handleExportProgressModalShown () {
      this.showExportContainer = true;
    },

    handleExportProgressModalHidden () {
      this.showExportContainer = false;
    },

    removePagesContainerElementAndRecreate() {
      document.querySelector('#progress-export-container').remove();
      const progressViewContainer = document.querySelector('#progress-view-container');
      const PAGES_CONTAINER = document.createElement('div');
      PAGES_CONTAINER.setAttribute('id', 'progress-export-container');
      progressViewContainer.appendChild(PAGES_CONTAINER);
    },

    resetDealsSvg() {
      this.svgIds.forEach((svgId) => {
        this.displaySvg[svgId] = true;
        this.pngSrc[svgId] = null;
      });
    },

    removeDealsImageCanvas() {
      this.$refs.canvas.remove();
    },

    async parseHtmlToCanvasAndCreateAnImage(params) {
    this.selectedDealsTypes = params.progressData.filter((selectedProgress) => {
        return this.dealsTypes.some(dealsType => dealsType === selectedProgress);
    });

    let firstSelectedDealsTypes = true; // Resetting the flag

    const progressImages = [];

    // Sequentially process each progress data
    for (const [i, selectedProgress] of params.progressData.entries()) {
        if (this.dealsTypes.indexOf(selectedProgress) > -1) {
            if (firstSelectedDealsTypes) {
                firstSelectedDealsTypes = false;

                const component = this.$refs['deals-started-closed-lost'];

                await component.waitForChartToBeRendered();

                const dealSvgToImageConversionPromises = this.svgIds.map((svgId) => this.convertSvgToImage(svgId));
                await Promise.all(dealSvgToImageConversionPromises);
                const image = await this.htmlToImage("#deals-started-closed-lost");
                progressImages.push(image);
            } // If required, you can add an 'else' branch here to handle other scenarios
        } else {
            const chart = this.progressCharts[selectedProgress];

            const chartComponent = this.$refs[chart.ref];

            await chartComponent.waitForChartToBeRendered();

            if (document.querySelector(chart.id)) {
                const image = await this.htmlToImage(chart.id);
                progressImages.push(image);
            } else {
                return Promise.reject(`Element ${chart.id} not found`);
            }
        }
    }

    this.selectedDealsTypes = ["deals.started", "deals.closed", "deals.lost"];

    // progressImages é um array de imagens de widgets do progresso
    try {
        // const imageSources = await buildPagesAndConvertToImages();
        Bus.$emit('resetSelectedDealsTypes');
        // this.removePagesContainerElementAndRecreate();
        this.resetDealsSvg();
        this.removeDealsImageCanvas();
        // chamada da função do back-end
        params.callback(progressImages.filter(progressImage => progressImage));
    } catch (error) {
        Bus.$emit('exportGraphsError', error);
    }
  },

    async htmlToImage(elementID) {
      return html2canvas(document.querySelector(elementID), {scale: this.deviceScale}).then(canvas => {
        return canvas.toDataURL('image/png');
      }).catch(error => console.error("Error converting to canvas:", error));
    },

    async convertSvgToImage(svgId) {
      if (document.querySelector(`#${svgId}-svg`)) {
        const canvas = this.$refs.canvas;  // assuming you have a ref="canvas" on your canvas element
        const ctx = canvas.getContext('2d');
        const svgElement = document.querySelector(`#${svgId}-svg`);  // assuming you have :ref="`${svgId}-svg`" on your svg elements

        const svgString = new XMLSerializer().serializeToString(svgElement);
        const svgBlob = new Blob([svgString], { type: "image/svg+xml;charset=utf-8" });
        const url = URL.createObjectURL(svgBlob);

        return new Promise((resolve) => {
          const img = new Image();
          img.onload = () => {
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            ctx.drawImage(img, 0, 0, 153, 153);
            const png = canvas.toDataURL('image/png');
            this.displaySvg[svgId] = false;
            this.pngSrc[svgId] = png;
            URL.revokeObjectURL(url);
            resolve();
          };
          img.src = url;
        });
      }
    },

    openExportModal () {
      Bus.$emit('openExportModal');
    },

    selectPipeline (pipeline) {
      this.pipeline.id = pipeline.id || '';
      this.pipeline.name = pipeline.name;
    },

    selectUser (user) {
      this.user.id = user.id || '';
      this.user.name = user.name;
    },
  },


};
</script>
